/**
 *
 * Asynchronously loads the component for ReferralComponent
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ReferralComponent = lazyLoad(
  () => import('./index'),
  module => module.ReferralComponent,
);
